import { Box, Stack } from "@mui/material";
import AddButton from "components/Buttons/AddButton";
import useScriptManagementStore from "../hooks/useScriptManagementStore";
import FormQuestion from "./components/FormQuestion";
import Question from "./components/Question";
import QuestionDropZone from "./components/QuestionDropZone";
import useFormHelpers from "./hooks/useFormHelpers";

export const QUESTION_DND_TYPE = "question";
export const OPTION_DND_TYPE = "option";
const ADD_QUESTION_BUTTON_OFFSET = 2;

export default function ScriptQuestions() {
  const { script, handleAddQuestion, editIndex } = useScriptManagementStore();
  const { isDraggable, isModerated } = useFormHelpers();

  if (isModerated()) {
    return <></>;
  }

  return (
    <Stack
      direction="column"
      sx={({ borders }) => ({
        mt: 2,
        p: 1,
        border: `1px solid ${borders.borderColor}`,
      })}
    >
      {script.questions.map((question, index) => (
        <Box key={`question${index}`}>
          {editIndex === index && (
            <FormQuestion question={question} index={index} />
          )}
          {editIndex !== index &&
            (isDraggable(question.type) ? (
              <>
                <QuestionDropZone index={index} />
                <Question
                  question={question}
                  index={index}
                  isDraggable
                  isEditable
                />
              </>
            ) : (
              <Question
                question={question}
                index={index}
                isDraggable={false}
                isEditable
                sx={index === 0 ? { mb: "1rem" } : null}
              />
            ))}
          {index === script.questions.length - ADD_QUESTION_BUTTON_OFFSET && (
            <>
              <QuestionDropZone index={index + 1} />
              <Box sx={{ mb: 2 }}>
                <AddButton
                  onClick={handleAddQuestion}
                  disabled={editIndex > -1}
                >
                  Add New Question
                </AddButton>
              </Box>
            </>
          )}
        </Box>
      ))}
    </Stack>
  );
}
